import { PersonnelService, } from "../../common/api.service";
import { FETCH_PERSON_ASSETS_END } from "../person_asset/mutations";
import { FETCH_PERSON_AVAILABILITYS_END } from "../person_availability/mutations";
import { FETCH_PERSON_COURSES_END } from "../person_course/mutations";
import { FETCH_PERSON_EMERGENCY_CONTACTS_END } from "../person_emergency_contact/mutations";
import { FETCH_PERSON_EMPLOYMENTS_END } from "../person_employment/mutations";
import { FETCH_PERSON_PHONE_NUMBER_END } from "../person_phone_number/mutations";
import { FETCH_PERSON_TEAM_END } from "../person_team/mutations";
import { FETCH_PERSON_VEHICLES_END } from "../person_vehicle/mutations";
import { DISMISS_TOASTER_MESSAGE, SET_TOASTER_MESSAGE } from "../this_app/mutations";
import { FETCH_PERSON, FETCH_PERSONNEL, SAVE_NEW_PERSON, SAVE_PERSON_MAIN_DETAILS_FIELD, SEND_DETAILS_CONFIRMATION } from "./actions";
import {
    CHANGE_NEW_PERSON_STEP,
    CLEAR_FILTER_PERSONNEL,
    FATAL_FETCH_ERROR,
    FILTER_PERSONNEL,
    FILTER_PERSONNEL_BY_DEPARTMENT,
    FILTER_PERSONNEL_BY_EMPLOYMENT_TYPE,
    FILTER_PERSONNEL_BY_IS_LIVE,
    FILTER_PERSONNEL_BY_JOB,
    LOAD_PERSON_SUMMARY_TO_EDIT,
    RESET_DEFAULT_PERSON_SUMMARY_TO_EDIT,
    RESET_NEW_PERSON_TO_DEFAULT,
    RESET_PERSON,
    SAVE_NEW_PERSON_SUCCESSFUL,
    SET_CONTRACTOR_STATUS,
    SET_EDIT_PERSON_FORM_SECTION_STATE,
    SET_NEW_PERSON_FORM_SECTION_STATE,
    SET_PERSON,
    SET_PERSONNEL,
    TOGGLE_EDIT_PERSON_SUMMARY_DIALOG,
    UPDATE_NEW_PERSON,
    UPDATE_PERSON_MAIN_DETAILS_FIELD,
} from "./mutations";

const state = {
    person: {},
    isContractor: false,
    personnelList: [],
    personnelFilter: '',
    personnelFilterByJob: '',
    personnelFilterByDepartment: '',
    personnelFilterByTeam: '',
    personnelFilterByEmploymentType: '',
    personnelFilterByIsLive: [
        {id: "isLive", state: true},
        {id: "notLive", state: false}
    ],
    personnelCount: 0,
    fatalFetchError: {
        state: false,
        value: "",
    },
    newPerson: {
        name: '',
        dateOfBirth: '',
        phoneNo: '',
        isLive: true,
        managerId: '',
        addresses: [
            {
                addressLineOne: undefined,
                addressLineTwo: undefined,
                town: undefined,
                county: undefined,
                postCode: undefined,
                personnelCountryId: undefined,
                comments: undefined,
                emailAddressPersonal: undefined,
                phoneNumber: undefined,
            }
        ],
        bankDetails: [
            {
                bankName: undefined,
                carriedOver: undefined,
                yearlyEntitlement: undefined,
                specialAllowance: undefined,
                comments: undefined,
                holidayPeriod: undefined
            }
        ],
        employments: [{
            jobId: undefined,
            ecsCompanyId: undefined,
            employmentTypeId: undefined,
            startDate: undefined,
            isCurrent: true,
            isAllowedToil: false,
            isAllowedExpenses: false,
        }],
        emergencyContacts: [{
            name: undefined,
            relationship: undefined,
            mobilePhone: undefined,
            startDate: undefined,
            endDatetime: undefined,
            comments: undefined,
            telephone: undefined,
            telephoneWork: undefined,
            addressLineOne: undefined,
            addressLineTwo: undefined,
            town: undefined,
            county: undefined,
            personnelCountryId: undefined,
            postCode: undefined,
            emailAddress: undefined,
        }],
        phoneNumbers: [{
            contactNumber: undefined,
            type: undefined,
            category: undefined,
            showInContactList: true,
        }],
        teams: [{
            teamId: undefined
        }]
    },
    editPerson: {
        name: undefined
    },
    editPersonSummaryDialog: false,
    newPersonStep: 1,
    newPersonFormState: {
        name: 'clean',
        phoneNumber: 'clean',
        address: 'clean',
        employment: 'clean',
        emergencyContact: 'clean',
    },
    saveNewPersonSuccessful: false,
    editPersonFormState: {
        summary: 'clean',
    }
};

const getDefaultState = () => {
    return {
        person: {},
        editPersonFormState: {
            summary: 'clean',
        },
        newPersonFormState: {
            name: 'clean',
            phoneNumber: 'clean',
            address: 'clean',
            employment: 'clean',
            emergencyContact: 'clean',
        },
        newPerson: {
            name: '',
            dateOfBirth: '',
            phoneNo: '',
            isLive: true,
            managerId: '',
            addresses: [
                {
                    addressLineOne: undefined,
                    addressLineTwo: undefined,
                    town: undefined,
                    county: undefined,
                    postCode: undefined,
                    personnelCountryId: undefined,
                    comments: undefined,
                    emailAddressPersonal: undefined,
                    phoneNumber: undefined,
                }
            ],
            bankDetails: [
                {
                    bankName: undefined,
                    carriedOver: undefined,
                    yearlyEntitlement: undefined,
                    specialAllowance: undefined,
                    comments: undefined,
                    holidayPeriod: undefined
                }
            ],
            employments: [{
                jobId: undefined,
                ecsCompanyId: undefined,
                employmentTypeId: undefined,
                startDate: undefined,
                isCurrent: true,
                isAllowedToil: false,
                isAllowedExpenses: false,
            }],
            emergencyContacts: [{
                name: undefined,
                relationship: undefined,
                mobilePhone: undefined,
                startDate: undefined,
                endDatetime: undefined,
                comments: undefined,
                telephone: undefined,
                telephoneWork: undefined,
                addressLineOne: undefined,
                addressLineTwo: undefined,
                town: undefined,
                county: undefined,
                personnelCountryId: undefined,
                postCode: undefined,
                emailAddress: undefined,
            }],
            phoneNumbers: [{
                contactNumber: undefined,
                type: undefined,
                category: undefined,
                showInContactList: true,
            }],
            teams: [{
                teamId: undefined
            }]
        },
    }
};

const getters = {
    totalStaff(state, getters) {
        return getters.personnelFilterByIsLiveState().count();
    },
    personnelFilterByIsLiveState(state) {
        let liveObject = state.personnelFilterByIsLive;
        let liveArray = [];
        for (let i = 0; i < liveObject.length; i++) {
            if (liveObject[i].state == true) {
                let newObject = {};
                newObject.id = liveObject[i].id;
                liveArray.push(newObject);
            }
        }
        return liveArray;
    },
    editPersonId(state) {
        if (state.editPerson !== undefined) {
            return state.editPerson.personId;
        }
    },
    saveNewPersonSuccessful(state) {
        return state.saveNewPersonSuccessful;
    },
    newPersonFormState: (state) => (section) => {
        return state.newPersonFormState[section];
    },
    editPersonFormState: (state) => (section) => {
        return state.editPersonFormState[section];
    },
    newPersonStep(state) {
        return state.newPersonStep;
    },
    editPersonSummaryDialog(state) {
        return state.editPersonSummaryDialog;
    },
    livePersonnel: (state) => () => {
        return state.personnelList.filter(person => person.isLive == true);
    },
    newPerson(state) {
        return state.newPerson;
    },
    fatalFetchError(state) {
        return state.fatalFetchError;
    },
    personnelFilter(state) {
        return state.personnelFilter;
    },
    personnelListForTable(state, getters) {
        let filteredPersonnelList = state.personnelList;
        if (state.personnelFilterByJob != '') {
            filteredPersonnelList = filteredPersonnelList.filter(function (itm) {
                if (itm.employments[0]) {
                    return state.personnelFilterByJob.includes(getters.getCurrentEmploymentForPerson(itm.personId).jobId);
                }
            });
        }
        if (state.personnelFilterByDepartment != '') {
            filteredPersonnelList = filteredPersonnelList.filter(function (itm) {
                if (itm.employments[0]) {
                    return state.personnelFilterByDepartment.includes(itm.employments[0].departmentId);
                }
            });
        }
        if (state.personnelFilterByTeam != '') {
            filteredPersonnelList = filteredPersonnelList.filter(function (itm) {
                if (itm.team) {
                    return state.personnelFilterByTeam.includes(itm.team.teamId);
                }
            });
        }
        if (state.personnelFilterByEmploymentType != '') {
            filteredPersonnelList = filteredPersonnelList.filter(function (itm) {
                if (itm.employments[0]) {
                    return state.personnelFilterByEmploymentType.includes(itm.employments[0].employmentTypeId);
                }
            });
        }
        if (state.personnelFilter != '') {
            filteredPersonnelList = filteredPersonnelList.filter(function (itm) {
                return itm.name.toUpperCase().includes(state.personnelFilter.toUpperCase());
            });
        }

        let liveState = false;
        let notLiveState = false;
        let personnelFilterByIsLive = state.personnelFilterByIsLive;

        if (state.personnelFilterByIsLive !== undefined) {
            for (let i = 0; i < personnelFilterByIsLive.length; i++) {
                let newState = state.personnelFilterByIsLive[i];

                if (newState.id == 'isLive') {
                    if (newState.state == true) {
                        liveState = true;
                    }
                }

                if (newState.id == 'notLive') {
                    if (newState.state == true) {
                        notLiveState = true;
                    }
                }
            }

        }

        if (liveState && !notLiveState) {
            filteredPersonnelList = filteredPersonnelList.filter(function (itm) {
                return itm.isLive;
            });
        } else if (!liveState && notLiveState) {
            filteredPersonnelList = filteredPersonnelList.filter(function (itm) {
                return !itm.isLive;
            });
        }

        filteredPersonnelList.forEach(function (item, key) {
            let jobName = getters.getJobNameById(getters.getCurrentEmploymentForPerson(item.personId).jobId);
            if (jobName == undefined) {
                jobName = "No Current Employment"
            }
            filteredPersonnelList[key]['jobName'] = jobName;
        });

        return filteredPersonnelList;
    },
    person(state) {
        return state.person;
    },
    getPersonNameById: (state) => (personId) => {
        let foundPerson = state.personnelList.find(searchPerson => searchPerson.personId == personId);

        if (foundPerson) {
            return foundPerson.name;
        }

        return '';
    },
    isContractorCheck(state) {
        let employment = {};
        if (state.person.employments) {
            employment = state.person.employments.find(employment => employment.isCurrent === true);
        }

        if (employment) {
            return employment.employmentTypeId == 2;
        }

        return false;
    },
    getCurrentEmploymentForPerson: (state) => (personId) => {
        const matches = state.personnelList.find(person => person.personId == personId);
        let employment = {};
        let personFromList = {};

        if (matches !== undefined) {
            personFromList = matches.employments.find(employment => {
                const compareDate = moment();
                const startDate = moment(employment.startDate, "YYYY-MM-DD");
                let endDate = moment().add(1, 'days');
                if (employment.endDate) {
                    endDate = moment(employment.endDate, "YYYY-MM-DD");
                }
                return compareDate.isBetween(startDate, endDate);
            });
        }

        if (personFromList !== undefined) {
            employment = personFromList;
        }

        return employment;
    },
    isContractor(state) {
        return state.isContractor;
    }
};

const actions = {
    [FETCH_PERSONNEL]({commit}) {
        let isLoading = true;
        setTimeout(function () {
            if (isLoading) {
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Loading...'});
            }
        }, 1000);
        return PersonnelService.getAllPersonnel()
            .then(({data}) => {
                isLoading = false;
                commit(SET_PERSONNEL, data);
                commit(DISMISS_TOASTER_MESSAGE);
            })
            .catch(error => {
                commit(FATAL_FETCH_ERROR, {state: true, value: "FETCH_PERSONNEL"});
                throw new Error(error);
            });
    },
    [FETCH_PERSON]({commit, getters}, personnelId) {
        return PersonnelService.getPerson(personnelId)
            .then(({data}) => {
                commit(RESET_PERSON);
                commit(SET_PERSON, data);
                const isContractor = getters.isContractorCheck;
                commit(SET_CONTRACTOR_STATUS, isContractor);
                commit(FETCH_PERSON_PHONE_NUMBER_END, data.phoneNumbers);
                commit(FETCH_PERSON_EMPLOYMENTS_END, data.employments);
                commit(FETCH_PERSON_VEHICLES_END, data.vehicles);
                commit(FETCH_PERSON_AVAILABILITYS_END, data.availabilityFull);
                commit(FETCH_PERSON_EMERGENCY_CONTACTS_END, data.emergencyContacts);
                commit(FETCH_PERSON_ASSETS_END, data.assets);
                commit(FETCH_PERSON_TEAM_END, data.teams);
                commit(FETCH_PERSON_COURSES_END, data.courses);
            })
            .catch(error => {
                throw new Error(error);
            });
    },
    [SAVE_NEW_PERSON]({state, dispatch, commit}) {

        return PersonnelService.saveNewPerson(state.newPerson)
            .then(({data}) => {
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Record updated'});
                commit(SAVE_NEW_PERSON_SUCCESSFUL, true);
                dispatch(FETCH_PERSONNEL, data);
            })
            .catch(error => {
                commit(SAVE_NEW_PERSON_SUCCESSFUL, false);
                if (error.request.status == 400) {
                    commit(SET_TOASTER_MESSAGE, {state: true, value: 'Form failed to save - API errors ' + error.request.responseText});
                }
            });
    },
    [SAVE_PERSON_MAIN_DETAILS_FIELD]({dispatch, commit}) {
        return PersonnelService.updatePersonPersonSummarys(state.editPerson)
            .then(({data}) => {
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Record updated'});
                dispatch(FETCH_PERSON, state.editPerson.personId);
                return data;
            });
    },
    [SEND_DETAILS_CONFIRMATION]({commit}, personnelId) {
        return PersonnelService.sendDetailsConfirmation(personnelId)
        .then(() => {
            commit(SET_TOASTER_MESSAGE, {state: true, value: 'Confirmation Email sent'});
        })
        .catch(error => {
            if (error.request.status == 400) {
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to send email - API errors ' + error.request.responseText});
            }
        });
    }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
    [SET_CONTRACTOR_STATUS](state, isContractor) {
        state.isContractor = isContractor;
    },
    [SAVE_NEW_PERSON_SUCCESSFUL](state, wasSuccessful) {
        state.saveNewPersonSuccessful = wasSuccessful;
    },
    [SET_NEW_PERSON_FORM_SECTION_STATE](state, params) {
        state.newPersonFormState[params.section] = params.state;
    },
    [SET_EDIT_PERSON_FORM_SECTION_STATE](state, params) {
        state.editPersonFormState[params.section] = params.state;
    },
    [CHANGE_NEW_PERSON_STEP](state, change) {
        const currentStep = state.newPersonStep;
        state.newPersonStep = currentStep + change;
    },
    [RESET_DEFAULT_PERSON_SUMMARY_TO_EDIT](state) {
        state.editPerson = state.defaultPerson;
    },
    [RESET_NEW_PERSON_TO_DEFAULT](state) {
        state.newPerson = getDefaultState().newPerson;
    },
    [TOGGLE_EDIT_PERSON_SUMMARY_DIALOG](state) {
        state.editPersonSummaryDialog = !state.editPersonSummaryDialog;
    },
    [LOAD_PERSON_SUMMARY_TO_EDIT](state) {
        // noinspection UnnecessaryLocalVariableJS
        state.editPerson = state.person;
    },
    [FATAL_FETCH_ERROR](state, data) {
        state.fatalFetchError.state = true;
        state.fatalFetchError.value = data.value;
    },
    [FILTER_PERSONNEL](state, value) {
        state.personnelFilter = value;
    },
    [FILTER_PERSONNEL_BY_JOB](state, value) {
        state.personnelFilterByJob = value;
    },
    [FILTER_PERSONNEL_BY_DEPARTMENT](state, value) {
        state.personnelFilterByDepartment = value;
    },
    [FILTER_PERSONNEL_BY_EMPLOYMENT_TYPE](state, value) {
        state.personnelFilterByEmploymentType = value;
    },
    [FILTER_PERSONNEL_BY_IS_LIVE](state, params) {
        const array = [];

        state.personnelFilterByIsLive = {};
        for (let value of params) {
            const object = {};
            object.id = value;
            object.state = true;
            array.push(object);

        }

        state.personnelFilterByIsLive = array;
    },
    [CLEAR_FILTER_PERSONNEL](state) {
        state.personnelFilter = '';
    },
    [UPDATE_PERSON_MAIN_DETAILS_FIELD](state, data) {
        if (data.objectKey !== undefined) {
            state.person[data.objectKey][0][data.field] = data.value;
        } else {
            state.person[data.field] = data.value;
        }
    },
    [UPDATE_NEW_PERSON](state, data) {
        if (data.objectKey !== undefined) {
            state.newPerson[data.objectKey][0][data.key] = data.value;
        } else {
            state.newPerson[data.key] = data.value;
        }

    },
    [SET_PERSONNEL](state, data) {
        state.personnelList = data;
        //state.articlesCount = articlesCount;
        state.isLoading = false;
    },
    [SET_PERSON](state, data) {
        state.person = data;
        state.loadingPerson = false;
    },
    [RESET_PERSON](state) {
        state.person = getDefaultState().person;
    }
};

export default {
    state,
    getters,
    actions,
    mutations,
};
